export default "__VITE_ASSET__63c9dcdf__"